import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import buildDataAttributes from "../../utils/buildDataAttributes.es.js";
import EzButtonLegacy from "./Implementations/EzButtonLegacy.es.js";
import EzButtonMui from "./Implementations/EzButtonMui.es.js";
const EzButton = forwardRef((props, ref) => {
  if (props.legacy === true) {
    const {
      legacy: _legacy,
      color: color2 = "primary",
      disabled: disabled2 = false,
      type: type2 = "button",
      ...remainingProps
    } = props;
    return /* @__PURE__ */ jsx(EzButtonLegacy, { ref, color: color2, disabled: disabled2, type: type2, ...remainingProps });
  }
  const {
    ariaHidden = false,
    ariaLabel,
    children,
    color = "primary",
    data,
    disabled = false,
    endIcon,
    fontSize = "medium",
    fullWidth = false,
    loading = false,
    onClick,
    onKeyDown,
    size = "medium",
    startIcon,
    type = "button",
    variant = "filled"
  } = props;
  return /* @__PURE__ */ jsx(
    EzButtonMui,
    {
      ref,
      ariaHidden,
      ariaLabel,
      color,
      disabled,
      endIcon,
      fontSize,
      fullWidth,
      loading,
      onClick,
      onKeyDown,
      size,
      startIcon,
      type,
      variant,
      ...buildDataAttributes({ data }),
      children
    }
  );
});
EzButton.displayName = "EzButton";
export {
  EzButton as default
};
//# sourceMappingURL=EzButton.es.js.map
